import React, { Component } from 'react';
import host from '../../assets/js/Host';
class EmployeeManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            employees: [],
            newEmployee: {
                name: '',
                password: '123456',
                phone: '',
                position: 1,
                shiftStart: 9,
                shiftEnd: 17,
                isBlocked: false,
                hasAllOrdersAccess: false,
                receivesOrders: true
            },
            editingEmployee: null,
            showAddForm: false,
            loading: true,
            error: null,
            selectedFilter: 'all',
            searchTerm: ''
        };
    }

    componentDidMount() {
        this.fetchEmployees();
    }

    // Function to handle back navigation
    handleGoBack = () => {
        window.history.back();
    };

    // Function to navigate to employee orders
    handleViewOrders = (employeeId) => {
        window.location.href = `/EmployeeOrders?id=${employeeId}`;
    };

    fetchEmployees = async () => {
        try {
            this.setState({ loading: true, error: null });

            const response = await fetch(`${host}dashbord/get_all_users/`);

            if (response.ok) {
                const data = await response.json();

                const employees = data.users.map(user => ({
                    id: user.id,
                    name: user.name,
                    password: user.password,
                    phone: user.phone,
                    position: user.role,
                    shiftStart: user.start || 9,
                    shiftEnd: user.end || 17,
                    isBlocked: user.isActive,
                    hasAllOrdersAccess: user.is_su || false,
                    receivesOrders: user.isOn || false
                }));

                this.setState({
                    employees: employees,
                    loading: false
                });
            } else {
                throw new Error('فشل في جلب بيانات الموظفين');
            }
        } catch (error) {
            console.error('خطأ في جلب الموظفين:', error);
            this.setState({
                error: 'فشل في تحميل بيانات الموظفين. تأكد من تشغيل الخادم.',
                loading: false
            });
        }
    };

    getPositionName = (position) => {
        switch (position) {
            case 1: return 'استجابة';
            case 0: return 'كول سنتر';
            case 3: return 'المتابعة';
            default: return 'غير محدد';
        }
    };

    getPositionIcon = (position) => {
        switch (position) {
            case 1: return '🎯';
            case 0: return '📞';
            case 3: return '📋';
            default: return '👤';
        }
    };

    getPositionGradient = (position) => {
        switch (position) {
            case 1: return 'linear-gradient(135deg, #11998e, #38ef7d)';
            case 0: return 'linear-gradient(135deg, #667eea, #764ba2)';
            case 3: return 'linear-gradient(135deg, #f093fb, #f5576c)';
            default: return 'linear-gradient(135deg, #6b7280, #9ca3af)';
        }
    };

    getFilteredEmployees = () => {
        const { employees, selectedFilter, searchTerm } = this.state;

        let filtered = employees;

        if (selectedFilter !== 'all') {
            if (selectedFilter === 'blocked') {
                filtered = filtered.filter(emp => emp.isBlocked);
            } else if (selectedFilter === 'active') {
                filtered = filtered.filter(emp => !emp.isBlocked);
            } else {
                filtered = filtered.filter(emp => emp.position === parseInt(selectedFilter));
            }
        }

        if (searchTerm.trim()) {
            filtered = filtered.filter(emp =>
                emp.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                emp.phone.includes(searchTerm)
            );
        }

        return filtered;
    };

    getEmployeeCounts = () => {
        const { employees } = this.state;
        return {
            all: employees.length,
            response: employees.filter(emp => emp.position === 1).length,
            callCenter: employees.filter(emp => emp.position === 0).length,
            followUp: employees.filter(emp => emp.position === 3).length,
            active: employees.filter(emp => !emp.isBlocked).length,
            blocked: employees.filter(emp => emp.isBlocked).length
        };
    };

    handleInputChange = (field, value, isEditing = false) => {
        if (field === 'phone') {
            value = value.replace(/[^0-9]/g, '');
        }

        if (isEditing) {
            this.setState({
                editingEmployee: {
                    ...this.state.editingEmployee,
                    [field]: value
                }
            });
        } else {
            const newState = {
                newEmployee: {
                    ...this.state.newEmployee,
                    [field]: value
                }
            };

            if (field === 'position' && parseInt(value) !== 0) {
                newState.newEmployee.hasAllOrdersAccess = false;
                newState.newEmployee.receivesOrders = false;
            }

            this.setState(newState);
        }
    };

    addEmployee = async () => {
        const { newEmployee, employees } = this.state;

        if (!newEmployee.name || !newEmployee.password || !newEmployee.phone) {
            alert('يرجى ملء جميع الحقول المطلوبة');
            return;
        }

        const employeeData = {
            name: newEmployee.name,
            password: newEmployee.password,
            phone: newEmployee.phone,
            role: parseInt(newEmployee.position)
        };

        if (parseInt(newEmployee.position) === 0) {
            employeeData.is_su = newEmployee.hasAllOrdersAccess;
            employeeData.is_on = newEmployee.receivesOrders;
            employeeData.start = newEmployee.shiftStart;
            employeeData.end = newEmployee.shiftEnd;
        }

        try {
            const response = await fetch(`${host}dashbord/add_new_user/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(employeeData)
            });

            if (response.ok) {
                const result = await response.json();
                console.log('تم إضافة الموظف بنجاح:', result);

                const employee = {
                    id: result.id || Date.now(),
                    name: newEmployee.name,
                    password: newEmployee.password,
                    phone: newEmployee.phone,
                    position: parseInt(newEmployee.position),
                    shiftStart: newEmployee.shiftStart,
                    shiftEnd: newEmployee.shiftEnd,
                    isBlocked: false,
                    hasAllOrdersAccess: newEmployee.hasAllOrdersAccess,
                    receivesOrders: newEmployee.receivesOrders
                };

                this.setState({
                    employees: [...employees, employee],
                    newEmployee: {
                        name: '',
                        password: '123456',
                        phone: '',
                        position: 1,
                        shiftStart: 9,
                        shiftEnd: 17,
                        isBlocked: false,
                        hasAllOrdersAccess: false,
                        receivesOrders: true
                    },
                    showAddForm: false
                });

                alert('تم إضافة الموظف بنجاح!');
                this.fetchEmployees();
            } else {
                const errorData = await response.json();
                console.error('خطأ في إضافة الموظف:', errorData);
                alert('حدث خطأ في إضافة الموظف: ' + (errorData.message || 'خطأ غير معروف'));
            }
        } catch (error) {
            console.error('خطأ في الاتصال بالخادم:', error);
            alert('خطأ في الاتصال بالخادم. تأكد من تشغيل الخادم على المنفذ 5000');
        }
    };

    startEditing = (employee) => {
        this.setState({
            editingEmployee: {
                ...employee,
                password: ''
            }
        });
    };

    saveEdit = async () => {
        const { editingEmployee, employees } = this.state;

        if (!editingEmployee.name || !editingEmployee.phone) {
            alert('يرجى ملء الحقول المطلوبة (الاسم ورقم الهاتف)');
            return;
        }

        const updateData = {
            name: editingEmployee.name,
            phone: editingEmployee.phone,
            role: editingEmployee.position,
            isActive: editingEmployee.isBlocked,
            is_on: editingEmployee.receivesOrders,
            is_su: editingEmployee.hasAllOrdersAccess
        };

        if (editingEmployee.password && editingEmployee.password.trim() !== '') {
            updateData.password = editingEmployee.password;
        }

        if (editingEmployee.position === 0) {
            updateData.start = editingEmployee.shiftStart;
            updateData.end = editingEmployee.shiftEnd;
        }

        try {
            const response = await fetch(`${host}dashbord/update_user/${editingEmployee.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updateData)
            });

            if (response.ok) {
                const result = await response.json();
                console.log('تم تحديث الموظف بنجاح:', result);

                this.setState({
                    employees: employees.map(emp =>
                        emp.id === editingEmployee.id ? editingEmployee : emp
                    ),
                    editingEmployee: null
                });

                alert('تم تحديث بيانات الموظف بنجاح!');
                this.fetchEmployees();
            } else {
                const errorData = await response.json();
                console.error('خطأ في تحديث الموظف:', errorData);
                alert('حدث خطأ في تحديث بيانات الموظف: ' + (errorData.message || 'خطأ غير معروف'));
            }
        } catch (error) {
            console.error('خطأ في الاتصال بالخادم:', error);
            alert('خطأ في الاتصال بالخادم. تأكد من تشغيل الخادم على المنفذ 5000');
            this.setState({ editingEmployee: null });
        }
    };

    cancelEdit = () => {
        this.setState({ editingEmployee: null });
    };

    toggleBlock = async (id) => {
        const employee = this.state.employees.find(emp => emp.id === id);
        if (!employee) return;

        const newBlockedStatus = !employee.isBlocked;

        try {
            const response = await fetch(`${host}dashbord/update_user/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    isActive: newBlockedStatus
                })
            });

            if (response.ok) {
                this.setState({
                    employees: this.state.employees.map(emp =>
                        emp.id === id ? { ...emp, isBlocked: newBlockedStatus } : emp
                    )
                });

                alert(newBlockedStatus ? 'تم حظر الموظف' : 'تم إلغاء حظر الموظف');
                this.fetchEmployees();
            } else {
                const errorData = await response.json();
                alert('حدث خطأ في تغيير حالة الموظف: ' + (errorData.message || 'خطأ غير معروف'));
            }
        } catch (error) {
            console.error('خطأ في تغيير حالة الموظف:', error);
            alert('خطأ في الاتصال بالخادم');
        }
    };

    generateTimeOptions = () => {
        const options = [];
        for (let i = 0; i < 24; i++) {
            options.push(
                <option key={i} value={i}>
                    {i.toString().padStart(2, '0')}:00
                </option>
            );
        }
        return options;
    };

    render() {
        const { employees, newEmployee, editingEmployee, showAddForm, selectedFilter, searchTerm } = this.state;
        const filteredEmployees = this.getFilteredEmployees();
        const counts = this.getEmployeeCounts();

        return (
            <div style={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #f1f5f9 0%, #e0e7ff 50%, #e5e7eb 100%)',
                fontFamily: 'Cairo, sans-serif',
                direction: 'rtl'
            }}>
                <style>
                    {`
            @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;500;600;700;800&display=swap');
            
            .glass-card {
              background: rgba(255, 255, 255, 0.9);
              backdrop-filter: blur(20px);
              border: 1px solid rgba(255, 255, 255, 0.2);
              box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
            }
            
            .hover-lift {
              transition: all 0.3s ease;
            }
            
            .hover-lift:hover {
              transform: translateY(-4px);
              box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
            }
            
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
            
            .btn-gradient {
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              border: none;
              color: white;
              font-weight: bold;
              cursor: pointer;
              transition: all 0.3s ease;
            }
            
            .btn-gradient:hover {
              transform: translateY(-2px);
              box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);
            }
            
            .btn-back {
              background: linear-gradient(135deg, #6b7280, #9ca3af);
              border: none;
              color: white;
              font-weight: bold;
              cursor: pointer;
              transition: all 0.3s ease;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            }
            
            .btn-back:hover {
              transform: translateY(-2px);
              box-shadow: 0 10px 25px rgba(107, 114, 128, 0.4);
            }
            
            .input-modern {
              border: 2px solid #e5e7eb;
              background: white;
              transition: all 0.3s ease;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
            }
            
            .input-modern:focus {
              border-color: #667eea;
              box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
              outline: none;
              background: white;
            }
            
            .form-label {
              display: block;
              margin-bottom: 0.5rem;
              font-weight: 600;
              color: #374151;
              font-size: 0.9rem;
            }

            .filter-button {
              padding: 0.75rem 1.5rem;
              border: 2px solid transparent;
              border-radius: 1rem;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.3s ease;
              background: rgba(255, 255, 255, 0.8);
              color: #6b7280;
            }

            .filter-button.active {
              background: linear-gradient(135deg, #3b82f6, #8b5cf6);
              color: white;
              border-color: transparent;
              box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
            }

            .filter-button:hover:not(.active) {
              background: rgba(255, 255, 255, 1);
              border-color: #3b82f6;
              transform: translateY(-2px);
            }
          `}
                </style>

                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem' }}>
                    {/* Back Button */}
                    <div style={{ position: 'absolute', top: '2rem', left: '2rem' }}>
                        <button
                            onClick={this.handleGoBack}
                            className="btn-back"
                            style={{
                                padding: '0.75rem 1.5rem',
                                borderRadius: '1rem',
                                fontSize: '1rem'
                            }}
                        >
                            <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                            </svg>
                            رجوع
                        </button>
                    </div>

                    <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
                        <div style={{
                            width: '80px',
                            height: '80px',
                            background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
                            borderRadius: '50%',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '1.5rem',
                            boxShadow: '0 10px 30px rgba(59, 130, 246, 0.3)'
                        }}>
                            <svg style={{ width: '40px', height: '40px', color: 'white' }} fill="currentColor" viewBox="0 0 20 20">
                                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <h1 style={{
                            fontSize: '3rem',
                            fontWeight: '800',
                            background: 'linear-gradient(135deg, #1f2937, #3b82f6, #8b5cf6)',
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            marginBottom: '1rem'
                        }}>
                            نظام إدارة الموظفين
                        </h1>
                        <p style={{ color: '#6b7280', fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto' }}>
                            منصة شاملة ومتطورة لإدارة الموظفين مع إمكانيات متقدمة للتحكم في الصلاحيات والشفتات
                        </p>
                    </div>

                    <div className="glass-card" style={{ borderRadius: '2rem', padding: '2rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem', flexWrap: 'wrap', gap: '1rem' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                <div style={{
                                    width: '60px',
                                    height: '60px',
                                    background: 'linear-gradient(135deg, #10b981, #3b82f6)',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <svg style={{ width: '30px', height: '30px', color: 'white' }} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" />
                                    </svg>
                                </div>
                                <div>
                                    <h2 style={{ fontSize: '1.8rem', fontWeight: '700', color: '#1f2937', margin: 0 }}>إدارة الموظفين</h2>
                                    <p style={{ color: '#6b7280', margin: 0 }}>أضف وأدر موظفيك بسهولة</p>
                                </div>
                            </div>
                            <button
                                className="btn-gradient"
                                onClick={() => this.setState({ showAddForm: !showAddForm })}
                                style={{
                                    padding: '0.75rem 2rem',
                                    borderRadius: '2rem',
                                    fontSize: '1rem'
                                }}
                            >
                                {showAddForm ? '✕ إلغاء' : '+ إضافة موظف جديد'}
                            </button>
                        </div>

                        <div style={{
                            background: 'rgba(255, 255, 255, 0.7)',
                            borderRadius: '1.5rem',
                            padding: '1.5rem',
                            marginBottom: '2rem',
                            border: '1px solid rgba(255, 255, 255, 0.3)'
                        }}>
                            <h3 style={{ fontSize: '1.2rem', fontWeight: '700', marginBottom: '1rem', color: '#1f2937' }}>
                                🔍 البحث والفلترة
                            </h3>

                            <div style={{ marginBottom: '1.5rem' }}>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => this.setState({ searchTerm: e.target.value })}
                                    className="input-modern"
                                    style={{
                                        width: '100%',
                                        padding: '0.75rem 1rem',
                                        borderRadius: '1rem',
                                        fontSize: '1rem'
                                    }}
                                    placeholder="🔍 ابحث بالاسم أو رقم الهاتف..."
                                />
                            </div>

                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', alignItems: 'center' }}>
                                <span style={{ fontWeight: '600', color: '#374151', marginLeft: '0.5rem' }}>فلترة حسب:</span>

                                <button
                                    className={`filter-button ${selectedFilter === 'all' ? 'active' : ''}`}
                                    onClick={() => this.setState({ selectedFilter: 'all' })}
                                >
                                    👥 الكل ({counts.all})
                                </button>

                                <button
                                    className={`filter-button ${selectedFilter === '1' ? 'active' : ''}`}
                                    onClick={() => this.setState({ selectedFilter: '1' })}
                                >
                                    🎯 استجابة ({counts.response})
                                </button>

                                <button
                                    className={`filter-button ${selectedFilter === '0' ? 'active' : ''}`}
                                    onClick={() => this.setState({ selectedFilter: '0' })}
                                >
                                    📞 كول سنتر ({counts.callCenter})
                                </button>

                                <button
                                    className={`filter-button ${selectedFilter === '3' ? 'active' : ''}`}
                                    onClick={() => this.setState({ selectedFilter: '3' })}
                                >
                                    📋 المتابعة ({counts.followUp})
                                </button>

                                <button
                                    className={`filter-button ${selectedFilter === 'active' ? 'active' : ''}`}
                                    onClick={() => this.setState({ selectedFilter: 'active' })}
                                >
                                    ✅ النشطون ({counts.active})
                                </button>

                                <button
                                    className={`filter-button ${selectedFilter === 'blocked' ? 'active' : ''}`}
                                    onClick={() => this.setState({ selectedFilter: 'blocked' })}
                                >
                                    🚫 المحظورون ({counts.blocked})
                                </button>
                            </div>
                        </div>

                        {showAddForm && (
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.7)',
                                borderRadius: '1.5rem',
                                padding: '2rem',
                                marginBottom: '2rem',
                                border: '1px solid rgba(255, 255, 255, 0.3)'
                            }}>
                                <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '1.5rem', color: '#1f2937' }}>
                                    📝 إضافة موظف جديد
                                </h3>

                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '1.5rem' }}>
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                                            اسم الموظف *
                                        </label>
                                        <input
                                            type="text"
                                            value={newEmployee.name}
                                            onChange={(e) => this.handleInputChange('name', e.target.value)}
                                            className="input-modern"
                                            style={{
                                                width: '100%',
                                                padding: '0.75rem 1rem',
                                                borderRadius: '0.75rem',
                                                fontSize: '1rem'
                                            }}
                                            placeholder="أدخل اسم الموظف"
                                        />
                                    </div>

                                    <div>
                                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                                            كلمة المرور *
                                        </label>
                                        <input
                                            type="password"
                                            value={newEmployee.password}
                                            onChange={(e) => this.handleInputChange('password', e.target.value)}
                                            className="input-modern"
                                            style={{
                                                width: '100%',
                                                padding: '0.75rem 1rem',
                                                borderRadius: '0.75rem',
                                                fontSize: '1rem'
                                            }}
                                            placeholder="أدخل كلمة المرور"
                                        />
                                    </div>

                                    <div>
                                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                                            رقم الهاتف *
                                        </label>
                                        <input
                                            type="tel"
                                            value={newEmployee.phone}
                                            onChange={(e) => this.handleInputChange('phone', e.target.value)}
                                            className="input-modern"
                                            style={{
                                                width: '100%',
                                                padding: '0.75rem 1rem',
                                                borderRadius: '0.75rem',
                                                fontSize: '1rem'
                                            }}
                                            placeholder="أدخل رقم الهاتف"
                                        />
                                    </div>

                                    <div>
                                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                                            منصب الموظف
                                        </label>
                                        <select
                                            value={newEmployee.position}
                                            onChange={(e) => this.handleInputChange('position', e.target.value)}
                                            className="input-modern"
                                            style={{
                                                width: '100%',
                                                padding: '0.75rem 1rem',
                                                borderRadius: '0.75rem',
                                                fontSize: '1rem'
                                            }}
                                        >
                                            <option value={1}>🎯 استجابة</option>
                                            <option value={0}>📞 كول سنتر</option>
                                            <option value={3}>📋 المتابعة</option>
                                        </select>
                                    </div>

                                    {parseInt(newEmployee.position) === 0 && (
                                        <>
                                            <div>
                                                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                                                    ⏰ بداية الشفت
                                                </label>
                                                <select
                                                    value={newEmployee.shiftStart}
                                                    onChange={(e) => this.handleInputChange('shiftStart', parseInt(e.target.value))}
                                                    className="input-modern"
                                                    style={{
                                                        width: '100%',
                                                        padding: '0.75rem 1rem',
                                                        borderRadius: '0.75rem',
                                                        fontSize: '1rem'
                                                    }}
                                                >
                                                    {this.generateTimeOptions()}
                                                </select>
                                            </div>

                                            <div>
                                                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                                                    ⏰ نهاية الشفت
                                                </label>
                                                <select
                                                    value={newEmployee.shiftEnd}
                                                    onChange={(e) => this.handleInputChange('shiftEnd', parseInt(e.target.value))}
                                                    className="input-modern"
                                                    style={{
                                                        width: '100%',
                                                        padding: '0.75rem 1rem',
                                                        borderRadius: '0.75rem',
                                                        fontSize: '1rem'
                                                    }}
                                                >
                                                    {this.generateTimeOptions()}
                                                </select>
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem', marginBottom: '2rem' }}>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                                        <input
                                            type="checkbox"
                                            checked={newEmployee.hasAllOrdersAccess}
                                            onChange={(e) => this.handleInputChange('hasAllOrdersAccess', e.target.checked)}
                                            style={{ width: '20px', height: '20px' }}
                                        />
                                        <span style={{ fontWeight: '600', color: '#374151' }}>🔑 صلاحية على كل الطلبات</span>
                                    </label>

                                    <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                                        <input
                                            type="checkbox"
                                            checked={newEmployee.receivesOrders}
                                            onChange={(e) => this.handleInputChange('receivesOrders', e.target.checked)}
                                            style={{ width: '20px', height: '20px' }}
                                        />
                                        <span style={{ fontWeight: '600', color: '#374151' }}>📥 يتلقى طلبات</span>
                                    </label>
                                </div>

                                <button
                                    onClick={this.addEmployee}
                                    style={{
                                        background: 'linear-gradient(135deg, #10b981, #3b82f6)',
                                        color: 'white',
                                        border: 'none',
                                        padding: '1rem 2rem',
                                        borderRadius: '1rem',
                                        fontSize: '1rem',
                                        fontWeight: '700',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    ✅ إضافة الموظف
                                </button>
                            </div>
                        )}

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem', flexWrap: 'wrap', gap: '1rem' }}>
                            <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', margin: 0 }}>
                                👥 النتائج {selectedFilter !== 'all' && `(${selectedFilter === '1' ? 'استجابة' :
                                    selectedFilter === '0' ? 'كول سنتر' :
                                        selectedFilter === '3' ? 'المتابعة' :
                                            selectedFilter === 'active' ? 'النشطون' :
                                                selectedFilter === 'blocked' ? 'المحظورون' : 'الكل'
                                    })`}
                                {searchTerm && ` - البحث: "${searchTerm}"`}
                            </h3>
                            <div style={{
                                background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
                                color: 'white',
                                padding: '0.5rem 1rem',
                                borderRadius: '2rem',
                                fontWeight: '700'
                            }}>
                                العدد: {filteredEmployees.length}
                            </div>
                        </div>

                        {filteredEmployees.length === 0 && (
                            <div style={{
                                textAlign: 'center',
                                padding: '3rem',
                                color: '#6b7280'
                            }}>
                                <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔍</div>
                                <h3 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                                    لا توجد نتائج
                                </h3>
                                <p>
                                    {searchTerm
                                        ? `لم يتم العثور على موظفين يطابقون البحث "${searchTerm}"`
                                        : 'لا يوجد موظفين في هذه الفئة'
                                    }
                                </p>
                            </div>
                        )}

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
                            gap: '1.5rem'
                        }}>
                            {filteredEmployees.map((employee) => (
                                <div key={employee.id} className="glass-card hover-lift" style={{ borderRadius: '1.5rem', padding: '1.5rem' }}>
                                    {editingEmployee && editingEmployee.id === employee.id ? (
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                            <h4 style={{ textAlign: 'center', color: '#1f2937', fontWeight: '700' }}>تعديل بيانات الموظف</h4>

                                            <div>
                                                <label className="form-label">اسم الموظف</label>
                                                <input
                                                    type="text"
                                                    value={editingEmployee.name}
                                                    onChange={(e) => this.handleInputChange('name', e.target.value, true)}
                                                    className="input-modern"
                                                    style={{
                                                        width: '100%',
                                                        padding: '0.875rem',
                                                        borderRadius: '0.75rem',
                                                        fontSize: '1rem'
                                                    }}
                                                    placeholder="اسم الموظف"
                                                />
                                            </div>

                                            <div>
                                                <label className="form-label">كلمة المرور</label>
                                                <input
                                                    type="password"
                                                    value={editingEmployee.password}
                                                    onChange={(e) => this.handleInputChange('password', e.target.value, true)}
                                                    className="input-modern"
                                                    style={{
                                                        width: '100%',
                                                        padding: '0.875rem',
                                                        borderRadius: '0.75rem',
                                                        fontSize: '1rem'
                                                    }}
                                                    placeholder="اتركها فارغة للاحتفاظ بكلمة المرور الحالية"
                                                />
                                            </div>

                                            <div>
                                                <label className="form-label">رقم الهاتف</label>
                                                <input
                                                    type="tel"
                                                    value={editingEmployee.phone}
                                                    onChange={(e) => this.handleInputChange('phone', e.target.value, true)}
                                                    className="input-modern"
                                                    style={{
                                                        width: '100%',
                                                        padding: '0.875rem',
                                                        borderRadius: '0.75rem',
                                                        fontSize: '1rem'
                                                    }}
                                                    placeholder="رقم الهاتف (أرقام فقط)"
                                                    pattern="[0-9]*"
                                                    inputMode="numeric"
                                                />
                                            </div>

                                            {editingEmployee.position === 0 && (
                                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                                                    <div>
                                                        <label className="form-label">بداية الشفت</label>
                                                        <select
                                                            value={editingEmployee.shiftStart}
                                                            onChange={(e) => this.handleInputChange('shiftStart', parseInt(e.target.value), true)}
                                                            className="input-modern"
                                                            style={{
                                                                width: '100%',
                                                                padding: '0.875rem',
                                                                borderRadius: '0.75rem',
                                                                fontSize: '1rem'
                                                            }}
                                                        >
                                                            {this.generateTimeOptions()}
                                                        </select>
                                                    </div>

                                                    <div>
                                                        <label className="form-label">نهاية الشفت</label>
                                                        <select
                                                            value={editingEmployee.shiftEnd}
                                                            onChange={(e) => this.handleInputChange('shiftEnd', parseInt(e.target.value), true)}
                                                            className="input-modern"
                                                            style={{
                                                                width: '100%',
                                                                padding: '0.875rem',
                                                                borderRadius: '0.75rem',
                                                                fontSize: '1rem'
                                                            }}
                                                        >
                                                            {this.generateTimeOptions()}
                                                        </select>
                                                    </div>
                                                </div>
                                            )}

                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={editingEmployee.hasAllOrdersAccess}
                                                        onChange={(e) => this.handleInputChange('hasAllOrdersAccess', e.target.checked, true)}
                                                    />
                                                    <span>🔑 صلاحية على كل الطلبات</span>
                                                </label>

                                                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={editingEmployee.receivesOrders}
                                                        onChange={(e) => this.handleInputChange('receivesOrders', e.target.checked, true)}
                                                    />
                                                    <span>📥 يتلقى طلبات</span>
                                                </label>
                                            </div>

                                            <div style={{ display: 'flex', gap: '0.5rem' }}>
                                                <button
                                                    onClick={this.saveEdit}
                                                    style={{
                                                        background: 'linear-gradient(135deg, #10b981, #3b82f6)',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '0.75rem 1rem',
                                                        borderRadius: '0.75rem',
                                                        fontSize: '0.9rem',
                                                        fontWeight: '600',
                                                        cursor: 'pointer',
                                                        flex: 1
                                                    }}
                                                >
                                                    ✅ حفظ
                                                </button>
                                                <button
                                                    onClick={this.cancelEdit}
                                                    style={{
                                                        background: '#6b7280',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '0.75rem 1rem',
                                                        borderRadius: '0.75rem',
                                                        fontSize: '0.9rem',
                                                        fontWeight: '600',
                                                        cursor: 'pointer',
                                                        flex: 1
                                                    }}
                                                >
                                                    ❌ إلغاء
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                                <div style={{
                                                    width: '60px',
                                                    height: '60px',
                                                    borderRadius: '50%',
                                                    background: this.getPositionGradient(employee.position),
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: 'white',
                                                    fontSize: '1.2rem',
                                                    fontWeight: '700',
                                                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)'
                                                }}>
                                                    {employee.name.split(' ')[0].charAt(0)}{employee.name.split(' ')[1]?.charAt(0) || ''}
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                    <h4 style={{ margin: 0, fontSize: '1.2rem', fontWeight: '700', color: '#1f2937' }}>
                                                        {employee.name}
                                                    </h4>
                                                    <p style={{
                                                        margin: 0,
                                                        background: 'rgba(255, 255, 255, 0.8)',
                                                        padding: '0.25rem 0.75rem',
                                                        borderRadius: '1rem',
                                                        fontSize: '0.8rem',
                                                        fontWeight: '600',
                                                        color: '#374151',
                                                        display: 'inline-block',
                                                        marginTop: '0.25rem'
                                                    }}>
                                                        {this.getPositionIcon(employee.position)} {this.getPositionName(employee.position)}
                                                    </p>
                                                </div>
                                            </div>

                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                                                <div style={{
                                                    background: 'linear-gradient(135deg, #dbeafe, #e0e7ff)',
                                                    padding: '0.75rem',
                                                    borderRadius: '0.75rem'
                                                }}>
                                                    <p style={{ margin: 0, fontSize: '0.8rem', color: '#6b7280' }}>📱 رقم الهاتف</p>
                                                    <p style={{ margin: 0, fontWeight: '700', color: '#1f2937' }}>{employee.phone}</p>
                                                </div>

                                                {employee.position === 0 && (
                                                    <div style={{
                                                        background: 'linear-gradient(135deg, #fce7f3, #f3e8ff)',
                                                        padding: '0.75rem',
                                                        borderRadius: '0.75rem'
                                                    }}>
                                                        <p style={{ margin: 0, fontSize: '0.8rem', color: '#6b7280' }}>⏰ ساعات العمل</p>
                                                        <p style={{ margin: 0, fontWeight: '700', color: '#1f2937' }}>
                                                            {employee.shiftStart.toString().padStart(2, '0')}:00 - {employee.shiftEnd.toString().padStart(2, '0')}:00
                                                        </p>
                                                    </div>
                                                )}
                                            </div>

                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                                                <span style={{
                                                    background: employee.isBlocked
                                                        ? 'linear-gradient(135deg, #fc466b, #3f5efb)'
                                                        : 'linear-gradient(135deg, #11998e, #38ef7d)',
                                                    color: 'white',
                                                    padding: '0.25rem 0.75rem',
                                                    borderRadius: '1rem',
                                                    fontSize: '0.75rem',
                                                    fontWeight: '700'
                                                }}>
                                                    {employee.isBlocked ? '🚫 محظور' : '✅ نشط'}
                                                </span>
                                                {employee.hasAllOrdersAccess && (
                                                    <span style={{
                                                        background: 'linear-gradient(135deg, #f093fb, #f5576c)',
                                                        color: 'white',
                                                        padding: '0.25rem 0.75rem',
                                                        borderRadius: '1rem',
                                                        fontSize: '0.75rem',
                                                        fontWeight: '700'
                                                    }}>
                                                        🔑 صلاحية كاملة
                                                    </span>
                                                )}
                                                {employee.receivesOrders && (
                                                    <span style={{
                                                        background: 'linear-gradient(135deg, #667eea, #764ba2)',
                                                        color: 'white',
                                                        padding: '0.25rem 0.75rem',
                                                        borderRadius: '1rem',
                                                        fontSize: '0.75rem',
                                                        fontWeight: '700'
                                                    }}>
                                                        📥 يتلقى طلبات
                                                    </span>
                                                )}
                                            </div>

                                            <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem' }}>
                                                <button
                                                    onClick={() => this.startEditing(employee)}
                                                    style={{
                                                        background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '0.75rem 1rem',
                                                        borderRadius: '0.75rem',
                                                        fontSize: '0.9rem',
                                                        fontWeight: '600',
                                                        cursor: 'pointer',
                                                        flex: 1,
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                >
                                                    ✏️ تعديل
                                                </button>
                                                
                                                <button
                                                    onClick={() => this.handleViewOrders(employee.id)}
                                                    style={{
                                                        background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '0.75rem 1rem',
                                                        borderRadius: '0.75rem',
                                                        fontSize: '0.9rem',
                                                        fontWeight: '600',
                                                        cursor: 'pointer',
                                                        flex: 1,
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                >
                                                    📋 الطلبات
                                                </button>
                                                
                                                <button
                                                    onClick={() => this.toggleBlock(employee.id)}
                                                    style={{
                                                        background: employee.isBlocked
                                                            ? 'linear-gradient(135deg, #10b981, #059669)'
                                                            : 'linear-gradient(135deg, #ef4444, #dc2626)',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '0.75rem 1rem',
                                                        borderRadius: '0.75rem',
                                                        fontSize: '0.9rem',
                                                        fontWeight: '600',
                                                        cursor: 'pointer',
                                                        flex: 1,
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                >
                                                    {employee.isBlocked ? '🔓 إلغاء الحظر' : '🔒 حظر'}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EmployeeManagement;